import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { createElement as h, Component } from 'react';
import DragDropPlugin from '@uppy/drag-drop';
import getHTMLProps from './getHTMLProps.js';
import nonHtmlPropsHaveChanged from './nonHtmlPropsHaveChanged.js';
/**
 * React component that renders an area in which files can be dropped to be
 * uploaded.
 */

var DragDrop =
/*#__PURE__*/
function (_Component) {
  _inherits(DragDrop, _Component);

  function DragDrop() {
    _classCallCheck(this, DragDrop);

    return _possibleConstructorReturn(this, _getPrototypeOf(DragDrop).apply(this, arguments));
  }

  _createClass(DragDrop, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.installPlugin();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // eslint-disable-next-line react/destructuring-assignment
      if (prevProps.uppy !== this.props.uppy) {
        this.uninstallPlugin(prevProps);
        this.installPlugin();
      } else if (nonHtmlPropsHaveChanged(this.props, prevProps)) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _this$props$target = _objectSpread({}, this.props, {
          target: this.container
        }),
            uppy = _this$props$target.uppy,
            options = _objectWithoutProperties(_this$props$target, ["uppy"]);

        this.plugin.setOptions(options);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.uninstallPlugin();
    }
  }, {
    key: "installPlugin",
    value: function installPlugin() {
      var _this$props = this.props,
          uppy = _this$props.uppy,
          locale = _this$props.locale,
          inputName = _this$props.inputName,
          width = _this$props.width,
          height = _this$props.height,
          note = _this$props.note,
          id = _this$props.id;
      var options = {
        id: id || 'DragDrop',
        locale: locale,
        inputName: inputName,
        width: width,
        height: height,
        note: note,
        target: this.container
      };
      uppy.use(DragDropPlugin, options);
      this.plugin = uppy.getPlugin(options.id);
    }
  }, {
    key: "uninstallPlugin",
    value: function uninstallPlugin(props) {
      if (props === void 0) {
        props = this.props;
      }

      var _props = props,
          uppy = _props.uppy;
      uppy.removePlugin(this.plugin);
    } // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return h('div', _objectSpread({
        className: 'uppy-Container',
        ref: function ref(container) {
          _this.container = container;
        }
      }, getHTMLProps(this.props)));
    }
  }]);

  return DragDrop;
}(Component);

export default DragDrop;